import { AppData, Step } from "../../AppDataProvider";

import { getFirstStep } from "../../../utils";

export type ResetAfterReservationExpiryOptions = {
  appData: AppData;
};

export const resetAfterReservationExpiry = (
  options: ResetAfterReservationExpiryOptions,
): AppData => {
  const updatedBookingData = options.appData.bookingData;
  delete updatedBookingData.reservedSpaceId;
  delete updatedBookingData.startDate;
  delete updatedBookingData.selectedBookings;

  const getCurrentStep = (): Step => {
    if (
      getFirstStep({
        bookingData: options.appData.bookingData,
        bookingTool: options.appData.bookingTool,
      }) === "locationAvailability"
    ) {
      return "locationAvailability";
    } else {
      return "availability";
    }
  };

  if (getCurrentStep() === "locationAvailability") {
    delete updatedBookingData.organisation;
    delete updatedBookingData.service;
  }

  return {
    ...options.appData,
    bookingData: updatedBookingData,
    currentStep: getCurrentStep(),
    showReservationExpiry: false,
  };
};
